import React from 'react';
import { Typography } from 'antd';

import { Attachment } from '../../components/Attachment';
import { StyledColumn } from '../../components/StyledColumn';
import { StyledRow } from '../../components/StyledRow';
import { AttachmentType } from '../emails/Emails.type';

type EmailAttachmentsProps = {
  attachments: AttachmentType[];
  setCvAttachement?: (id: string) => void;
};

export const EmailAttachments: React.FC<EmailAttachmentsProps> = ({ attachments, setCvAttachement }) => {
  return (
    <StyledColumn>
      <Typography.Title level={5} style={{ paddingLeft: '15px' }}>
        Attachements
      </Typography.Title>
      <StyledRow justifyContent="flex-start" padding="0 25px">
        {attachments.map((attachment) => (
          <Attachment key={attachment.fileId} setCvAttachement={setCvAttachement} attachment={attachment} />
        ))}
      </StyledRow>
    </StyledColumn>
  );
};
